import { render, staticRenderFns } from "./InputButton.vue?vue&type=template&id=68f3977f&"
import script from "./InputButton.vue?vue&type=script&lang=js&"
export * from "./InputButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports